import * as React from "react";
import { ReactComponent as AddTimeIcon } from "src/images/timer-icons/add.svg";
import { ReactComponent as CancelIcon } from "src/images/timer-icons/cancel.svg";
import { ReactComponent as RestartIcon } from "src/images/timer-icons/restart.svg";
import { TimerMenu, TimerMenuItem } from "../Timer.components";

interface TimerStartedMenuProps {
  onAdd30Sec: () => void | Promise<void>;
  onRestartTimer: () => void | Promise<void>;
  onCancelTimer: () => void | Promise<void>;
}

export const TimerStartedMenu: React.FunctionComponent<
  TimerStartedMenuProps
> = ({ onAdd30Sec, onRestartTimer, onCancelTimer }) => {
  return (
    <TimerMenu>
      <TimerMenuItem onClick={onAdd30Sec}>
        <AddTimeIcon />
        <span>Add 30 seconds</span>
      </TimerMenuItem>
      <TimerMenuItem onClick={onRestartTimer}>
        <RestartIcon />
        <span>Restart Timer</span>
      </TimerMenuItem>
      <TimerMenuItem onClick={onCancelTimer}>
        <CancelIcon />
        <span>Cancel Timer</span>
      </TimerMenuItem>
    </TimerMenu>
  );
};
